import React from "react";

const Clock = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        opacity="0.4"
        cx="6.99992"
        cy="7.00001"
        r="6.66667"
        fill="#6B50FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.81079 3.84784C7.08693 3.84784 7.31079 4.0717 7.31079 4.34784V7.32079L8.9689 7.8735C9.23088 7.96082 9.37246 8.24398 9.28513 8.50595C9.19781 8.76793 8.91465 8.9095 8.65268 8.82218L6.65268 8.15551C6.44851 8.08746 6.31079 7.89639 6.31079 7.68117V4.34784C6.31079 4.0717 6.53465 3.84784 6.81079 3.84784Z"
        fill="#6B50FF"
      />
    </svg>
  );
};

export default Clock;
